export function escapeRegExp(text) {
  return text.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
